.container {
  display: inline-flex;
  align-items: center;
  gap: var(--fly-number-spacing-2);
  opacity: 0.64;
  width: 100%;
}

.text {
  order: 2;
}

.icon {
  order: 1;
}

.dot {
  animation: blink 1.4s infinite both;
  font-size: var(--fly-typography-size-5);

  &:nth-child(1) {
    animation-delay: 0s;
  }

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }
}

@keyframes blink {
  0%,
  80%,
  100% {
    opacity: 0.2;
  }
  40% {
    opacity: 1;
  }
}
